module.exports = __webpack_public_path__ + "img/5.ab2e5a9f.png";